import { render } from "./MySkills.vue?vue&type=template&id=0671fd87&scoped=true"
import script from "./MySkills.vue?vue&type=script&lang=js"
export * from "./MySkills.vue?vue&type=script&lang=js"

import "./MySkills.vue?vue&type=style&index=0&id=0671fd87&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0671fd87"]])

export default __exports__